<template>
  <div class="trackcode-container">
    <el-row>
      <el-col :span="24">
        <el-card class="status-cards-card" shadow="hover">
          <template #header>
            <div class="status-header">
              <font-awesome-icon icon="chart-line" class="status-header-icon" />
              <span class="status-header-title">Төлөвийн статистик</span>
            </div>
          </template>
          <el-row :gutter="8" justify="space-between" class="status-cards-row">
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-primary" @click="loadData(100)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-plus" class="status-icon"/>
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalHereglegchBvrgesen }}</div>
                  <div class="status-label">Хэрэглэгч бүртгэсэн</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-info" @click="loadData(120)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-map-marker-alt" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalMongolSalbar }}</div>
                  <div class="status-label">Монгол салбарт</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-success" @click="loadData(110)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-warehouse" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalEreenAguulah }}</div>
                  <div class="status-label">Эрээнээс гарсан</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-warning" @click="loadData(130)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-shipping-fast" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalHvrgelt }}</div>
                  <div class="status-label">Хүргэлтээр авна</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-danger" @click="loadData(190)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-car" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ cancelTrackCode }}</div>
                  <div class="status-label">Цуцалсан</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-secondary" @click="loadData(150)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-box" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalHadgaluulah }}</div>
                  <div class="status-label">Салбарт хадгалуулна</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-info" @click="loadData(140)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-person-walking" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalOchijAvah }}</div>
                  <div class="status-label">Очиж авна</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-warning" @click="loadData(170)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-building" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalSalbartUldsen }}</div>
                  <div class="status-label">Салбарт үлдсэн</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-success" @click="loadData(180)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-check-circle" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ checkTrackCode }}</div>
                  <div class="status-label">Ачаа шалгуулах</div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="6" :sm="4" :md="3" :lg="2" :xl="2">
              <el-card class="modern-status-card status-card-primary" @click="loadData(200)">
                <div class="status-icon-wrapper">
                  <font-awesome-icon icon="fas fa-check-circle" class="status-icon" />
                </div>
                <div class="status-content">
                  <div class="status-value">{{ totalHvleenAwsan }}</div>
                  <div class="status-label">Хүлээн авсан</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- <el-row class="mt-2">
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Төлбөр төлөх" placement="top-start">
          <el-button style="background-color: #2a8000; color: white;">
            <font-awesome-icon icon="fas fa-dollar-sign"/>
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Хүргэлтэнд гаргах" placement="top-start">
          <el-button type="warning">
            <font-awesome-icon icon="fas fa-truck" />
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Монгол дах салбар хүлээн авсан" placement="top-start">
          <el-button type="primary">
            <font-awesome-icon icon="fas fa-map-marker-alt" />
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Хэрэглэгчид олгох" placement="top-start">
          <el-button type="success">
            <font-awesome-icon icon="fas fa-users" />
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Хэрэглэгч салбар дээр хадгалуулна" placement="top-start">
          <el-button style="background-color: #000066; color: white;">
            <font-awesome-icon icon="fas fa-archive" />
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Хэрэглэгч салбараас очиж авна" placement="top-start">
          <el-button style="background-color: #0066cc; color: white;">
            <font-awesome-icon icon="fas fa-person-walking" />
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Хүргэлтэнд гаргах | Төлбөр төлөх" placement="top-start">
          <el-button style="background-color: #2929a3; color: white;">
            <font-awesome-icon icon="fas fa-shipping-fast" />
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Хэрэглэгчид олгох | Төлбөр төлөх" placement="top-start">
          <el-button style="background-color: #003380; color: white;">
            <font-awesome-icon icon="fas fa-hand-holding-usd" />
          </el-button>
        </el-tooltip>
      </el-col>
      <el-col :span="2" class="mb-2">
        <el-tooltip class="item" effect="dark" content="Ачаа салбар дээр үлдсэн" placement="top-start">
          <el-button style="background-color: #003380; color: white;">
            <font-awesome-icon icon="fas fa-hourglass-half" />
          </el-button>
        </el-tooltip>
      </el-col>
    </el-row> -->
    <el-row class="mt-5">
      <el-col :span="24">
        <el-card>
          <el-row>
            <el-col :span="2" class="ml-5">
              <el-button type="success" @click="loadDataDownloadExcel">Excel татах</el-button>
            </el-col>
            <el-col :span="6">
              <div>
                <el-date-picker v-model="startDate" placeholder="Эхлэх огноо" style="width: 150px;"></el-date-picker> -
                <el-date-picker v-model="endDate" placeholder="Дуусах огноо" style="width: 150px;"></el-date-picker>
                <el-button type="success" @click="loadData(this.progress_code)"><font-awesome-icon icon="fas fa-search"/></el-button>
              </div>
            </el-col>
            <el-col :span="6" class="m-l-50">
              <el-input v-model="searchQuery" placeholder="Утасны дугаар эсвэл трак код оруулна уу" clearable />
            </el-col>
            <el-col :span="2">
              <el-button type="success" @click="searchItem(searchQuery)"><font-awesome-icon icon="fas fa-search"/></el-button>
            </el-col>
            <el-col :span="6">
              <el-select class="w-100" v-model="progress_name_dialog" @change="openDialog" placeholder="Сонгоно уу">
                <el-option value="is_paid" label="Төлбөр төлөх">
                  <font-awesome-icon icon="fas fa-dollar-sign" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Төлбөр төлөх
                </el-option>
                <el-option value="is_delivery" label="Хүргэлтэнд гаргах">
                  <font-awesome-icon icon="fas fa-truck" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Хүргэлтэнд гаргах
                </el-option>
                <el-option value="is_give" label="Хэрэглэгчид олгох">
                  <font-awesome-icon icon="fas fa-users" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Хэрэглэгчид олгох
                </el-option>
                <el-option value="is_paid_and_delivery" label="Хүргэлтэнд гаргах | Төлбөр төлөх">
                  <font-awesome-icon icon="fas fa-shipping-fast" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Хүргэлтэнд гаргах | Төлбөр төлөх
                </el-option>
                <el-option value="is_paid_and_give_user" label="Хэрэглэгчид олгох | Төлбөр төлөх">
                  <font-awesome-icon icon="fas fa-hand-holding-usd" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Хэрэглэгчид олгох | Төлбөр төлөх
                </el-option>
                <el-option value="is_get" label="Хэрэглэгч салбараас очиж авна">
                  <font-awesome-icon icon="fas fa-person-walking" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Хэрэглэгч салбараас очиж авна
                </el-option>
                <el-option value="is_branch" label="Хэрэглэгч салбар дээр хадгалуулна">
                  <font-awesome-icon icon="fas fa-archive" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Хэрэглэгч салбар дээр хадгалуулна
                </el-option>
                <el-option value="is_uldsen" label="Ачаа салбар дээр үлдсэн">
                  <font-awesome-icon icon="fas fa-hourglass-half" class="icon_color" />&nbsp;&nbsp;&nbsp;
                  Ачаа салбар дээр үлдсэн
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="mt-2 mb-2">
            <el-col :span="3" v-if="this.formDataDialog && this.formDataDialog.countTrackCode" >
              <el-tag type="warning">Нийт үнэ: {{ $formatCurrency(this.formDataDialog.totalPrice) }}</el-tag>
            </el-col>
            <el-col :span="3" v-if="this.formDataDialog && this.formDataDialog.countTrackCode"  class="ml-5">
              <el-tag type="warning">Нийт тоо: {{ this.formDataDialog.countTrackCode }}</el-tag>
            </el-col>
            <el-col :span="3" v-if="this.sumTransaction" class="ml-5">
              <el-tag>Шилжүүлэг: {{ $formatCurrency(this.sumTransaction) }}</el-tag>
            </el-col>
            <el-col :span="3" v-if="this.sumCash">
              <el-tag>Бэлэн төлсөн: {{ $formatCurrency(this.sumCash) }}</el-tag>
            </el-col>
            <el-col :span="3" v-if="this.sumCard" class="ml-5">
              <el-tag>Бэлэн мөнгө: {{ $formatCurrency(this.sumCard) }}</el-tag>
            </el-col>
            <el-col :span="3" v-if="this.sumNotPay" class="ml-5">
              <el-tag>Төлбөргүй:  {{ $formatCurrency(this.sumNotPay) }}</el-tag>
            </el-col>
          </el-row>
          <el-table :data="data" row-key="track_code" order class="mt-2" @selection-change="handleSelectionChange">
            <el-table-column type="selection" fixed="left"></el-table-column>
            <el-table-column label="№" prop="id" width="70px" fixed="left"></el-table-column>
            <el-table-column label="Track code" prop="track_code" width="220px" fixed="left"></el-table-column>
            <el-table-column v-if="checkPermissionsPage('admin')" label="Төлөв" width="260px">
                <template #default="scope">
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 100" class="cursor">Хэрэглэгч бүртгэсэн </el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 110" class="cursor">Эрээн дах агуулахаас гарсан</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 120" class="cursor">Монгол дах салбар хүлээн авсан</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 200" class="cursor">Хэрэглэгч хүлээн авсан</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 130" class="cursor">Хэрэглэгч хүргэлтээр авна</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 140" class="cursor">Хэрэглэгч салбараас очиж авна</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 150" class="cursor">Хэрэглэгч салбар дээр хадгалуулна</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 160" class="cursor">Хүргэлтийн ажилтанд хуваарилсан</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 170" class="cursor">Ачаа салбар дээр үлдсэн</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 109" class="cursor" type="danger">Тодорхойгүй</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 180" class="cursor" type="danger"> Трак код шалгуулах</el-tag>
                  <el-tag @click="seeTrackCodeProgressDialogOpen(scope.row)" v-if="scope.row.progress_code && scope.row.progress_code === 190" class="cursor" type="danger">Цуцалсан</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="Утасны дугаар" prop="phone_number" width="150px"></el-table-column>
            <el-table-column label="Хугацаа" width="130px">
                <template v-slot:default="scope">
                  <el-tag type="warning" effect="dark">{{ timeSince(scope.row.progress_created_at) }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="Үүсгэсэн огноо" width="150px">
                <template v-slot:default="scope">
                  <div type="warning" effect="dark">{{ scope.row.progress_created_at.split('T')[0] }}</div>
                </template>
            </el-table-column>
            <el-table-column label="Ачааны үнэ">
              <template v-slot="scope">
                {{ $formatCurrency(scope.row.price) }}
              </template>
            </el-table-column>
            <el-table-column label="Төлсөн төлбөр">
              <template v-slot="scope">
                {{ $formatCurrency(scope.row.price_to_pay) }}
              </template>
            </el-table-column>
            <el-table-column label="Төлбөр" width="100px" :filters="[ { text: 'Төлсөн', value: true }, { text: 'Төлөөгүй', value: false } ]" :filter-method="filterPaid">
              <template v-slot="scope">
                <el-tag type="success" v-if="scope.row.is_paid === true">
                  Төлсөн
                </el-tag>
                <el-tag type="danger" v-else>
                  Төлөөгүй
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column v-if="this.progress_code === 150" label="Эхлэх огноо" prop="start_date">
            </el-table-column>
            <!-- <el-table-column label="Ирсэн салбар" prop="irsen_salbariin_ner">
            </el-table-column> -->
            <el-table-column label="Төлбөрийн хэлбэр" width="170px" :filters="[
                { text: 'Бэлэн төлөлт', value: 'cash' },
                { text: 'Шүлжүүлэг', value: 'transaction' },
                { text: 'Карт', value: 'card' },
                { text: 'Төлбөргүй', value: 'notpay' },
                { text: 'Купон', value: 'cupon' }
              ]" :filter-method="filterPaidType">
              <template v-slot="scope">
                {{ paidTypeLabel(scope.row.paid_type) }}
              </template>
            </el-table-column>
            <el-table-column label="Ирсэн салбар" prop="irsen_salbariin_ner" width="200px" :filters="[ { text: 'Бөхийн өргөө салбар', value: 'Бөхийн өргөө салбар' }, { text: 'Офицер салбар', value: 'Офицер салбар' } ]" :filter-method="filterIrsenSalbar">
            </el-table-column>
            <!-- <el-table-column label="Үйлдэл">
              <el-button>Мессэж</el-button>
            </el-table-column> -->
          </el-table>
        <!-- Pagination -->
        <el-pagination
          @current-change="handlePageChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalRecords"
          layout="total, prev, pager, next, jumper"
          style="margin-top: 20px; text-align: right;" />
        </el-card>
      </el-col>
    </el-row>
    <!-- Төлбөр төлөх -->
    <el-dialog title="Төлбөр төлөх" v-model="is_paid_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <div>
        <el-switch class="mb-3" inline-prompt style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" active-text="Төлсөн" inactive-text="Төлөөгүй" v-model="this.formDataDialog.is_paid" :active-value="1" :inactive-value="0"></el-switch>
        <div v-if="this.formDataDialog.is_paid === 1">
          Төлбөрийн хэлбэр:<br>
          <el-radio-group v-model="this.formDataDialog.paid_type">
            <el-radio label="cash">Бэлэн мөнгө</el-radio><br>
            <el-radio label="transaction">Шилжүүлэг</el-radio><br>
            <el-radio label="card">Карт</el-radio><br>
            <el-radio label="notpay" class="button_bottom">Төлбөр төлөхгүй</el-radio>
          </el-radio-group><br><br>
          <el-button type="success" @click="paymentSuccess()">Төлбөр төлөх</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- Хүргэлтэнд гаргах -->
    <el-dialog title="Хүргэлтэнд гаргах" v-model="is_delivery_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <hr class="mb-5">
      <div v-if="this.user.length">
        <div v-for="items in user" :key="items.id">
          <div v-for="item in items" :key="item.id">
            <div>
              <span style="color: blue;">{{ item.phone1 }}</span> дугаартай хэрэглэгчийн хаягийн жагсаалт:
            </div>
            <el-radio-group class="vertical-radio-group mb-5" v-model="this.formDataDialog.address_id" style="width:100%">
              <el-radio-button v-for="(itemd, index) in item.Address" :key="index" :label="itemd.id" :value="itemd.id" style="margin: 5px;" class="selected-address">
                {{ itemd.detail_address }}
              </el-radio-button><br/>
            </el-radio-group>
          </div>
        </div>
      </div>
      <hr class="mb-5">
      <b>Хүргэлтийн ажилтан сонгоно уу</b>
      <el-select v-model="this.formDataDialog.driver_id" placeholder="Сонгоно уу">
        <el-option v-for="item in this.driversList" :key="item.id" :value="item.id" :label="item.firstName"></el-option>
      </el-select>
      <el-button v-if="this.formDataDialog.driver_id" type="success" class="mt-5" @click="hurgeltendGargahCheck()">Хүргэлтэнд гаргах</el-button>
    </el-dialog>
    <!-- Хэрэглэгчид олгох -->
    <el-dialog title="Хэрэглэгчид олгох" v-model="is_give_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <hr class="mb-5">
      <el-button type="success" class="mt-5" @click="hereglegchidOlgohCheck()">Хэрэглэгчид олгох</el-button>
    </el-dialog>
    <!-- Хүргэлтэнд гаргах | Төлбөр төлөх -->
    <el-dialog title="Хүргэлтэнд гаргах | Төлбөр төлөх" v-model="is_paid_and_delivery_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <hr class="mb-5">
      <div>
        <el-switch class="mb-3" inline-prompt style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" active-text="Төлсөн" inactive-text="Төлөөгүй" v-model="this.formDataDialog.is_paid" :active-value="1" :inactive-value="0"></el-switch>
        <div v-if="this.formDataDialog.is_paid === 1">
          Төлбөрийн хэлбэр:<br>
          <el-radio-group v-model="this.formDataDialog.paid_type">
            <el-radio label="cash">Бэлэн мөнгө</el-radio><br>
            <el-radio label="transaction">Шилжүүлэг</el-radio><br>
            <el-radio label="card">Карт</el-radio><br>
            <el-radio label="notpay" class="button_bottom">Төлбөр төлөхгүй</el-radio>
          </el-radio-group>
        </div>
      </div>
      <hr class="mb-5">
      <div v-if="this.user.length">
        <div v-for="items in user" :key="items.id">
          <div v-for="item in items" :key="item.id">
            <div>
              <span style="color: blue;">{{ item.phone1 }}</span> дугаартай хэрэглэгчийн хаягийн жагсаалт:
            </div>
            <el-radio-group class="vertical-radio-group mb-5" v-model="this.formDataDialog.address_id" style="width:100%">
              <el-radio-button v-for="(itemd, index) in item.Address" :key="index" :label="itemd.id" :value="itemd.id" style="margin: 5px;" class="selected-address">
                {{ itemd.detail_address }}
              </el-radio-button><br/>
            </el-radio-group>
          </div>
        </div>
      </div>
      <hr class="mb-5">
      <b>Хүргэлтийн ажилтан сонгоно уу</b>
      <el-select v-model="this.formDataDialog.driver_id" placeholder="Сонгоно уу">
        <el-option v-for="item in this.driversList" :key="item.id" :value="item.id" :label="item.firstName"></el-option>
      </el-select>
      <el-button v-if="this.formDataDialog.driver_id" type="success" class="mt-5" @click="paymentAndDelivery()">Хүргэлтэнд гаргах | Төлбөр төлөх</el-button>
    </el-dialog>
        <!-- Хүргэлтэнд гаргах | Төлбөр төлөх -->
    <el-dialog title="Хэрэглэгчид олгох | Төлбөр төлөх" v-model="is_paid_and_give_user_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <hr class="mb-5">
      <div>
        <el-switch class="mb-3" inline-prompt style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949" active-text="Төлсөн" inactive-text="Төлөөгүй" v-model="this.formDataDialog.is_paid" :active-value="1" :inactive-value="0"></el-switch>
        <div v-if="this.formDataDialog.is_paid === 1">
          Төлбөрийн хэлбэр:<br>
          <el-radio-group v-model="this.formDataDialog.paid_type">
            <el-radio label="cash">Бэлэн мөнгө</el-radio><br>
            <el-radio label="transaction">Шилжүүлэг</el-radio><br>
            <el-radio label="card">Карт</el-radio><br>
            <el-radio label="notpay" class="button_bottom">Төлбөр төлөхгүй</el-radio>
          </el-radio-group>
        </div>
      </div>
      <el-button type="success" class="mt-5" @click="paymentAndGiveUser()">Хэрэглэгчид олгох | Төлбөр төлөх</el-button>
    </el-dialog>
    <!-- Хэрэглэгч салбараас очиж авна -->
    <el-dialog title="Хэрэглэгч салбараас очиж авна" v-model="is_get_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <hr class="mb-5">
      <el-button type="success" class="mt-5" @click="getCheck()">Хэрэглэгч салбараас очиж авна</el-button>
    </el-dialog>
    <!-- Хэрэглэгч салбар дээр хадгалуулна -->
    <el-dialog title="Хэрэглэгч салбар дээр хадгалуулна" v-model="is_branch_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <hr class="mb-5">
      <div class="block">
        <el-date-picker v-model="this.formDataDialog.startDate" type="date" placeholder="Эхлэх огноо"></el-date-picker>
      </div><br>
      <div class="block">
        <el-date-picker v-model="this.formDataDialog.endDate" type="date" placeholder="Дуусах огноо"></el-date-picker><br><br>
      </div>
      <el-button type="success" class="mt-5" @click="saveCheck()">Хэрэглэгч салбар дээр хадгалуулна</el-button>
    </el-dialog>
    <!-- Ачаа салбар дээр үлдсэн -->
    <el-dialog title="Ачаа салбар дээр үлдсэн" v-model="is_uldsen_dialog" width="50%" center>
      <el-card>
        <div class="mb-2">
          Таны сонгосон трак код:
        </div>
        <div v-if="this.formDataDialog.selectedTrackCodes" class="mb-3">
          <el-tag v-for="item in this.formDataDialog.selectedTrackCodes" :key="item.id" class="mr-2 mb-2">{{ item }}</el-tag>
        </div>
      </el-card><br>
      <div class="mb-2">
        Нийт төлбөр: {{ $formatCurrency(this.formDataDialog.totalPrice) }}
      </div>
      <div class="mb-5">
        Нийт тоо: {{ this.formDataDialog.countTrackCode }}
      </div>
      <hr class="mb-5">
      <div class="block">
        <el-input v-model="this.formDataDialog.description" type="textarea" placeholder="Тайлбар оруулна уу"></el-input>
      </div><br>
      <el-button type="success" class="mt-5" @click="atBranchCheck()">Ачаа салбар дээр үлдсэн</el-button>
    </el-dialog>
    <CreateTrackCodeDialog :selectedTrackCode="this.targetTrackCode" />
    <SeeTrackCodeProgressDialog :selectedTrackCode="this.formData" />
  </div>
</template>

<script>
import services from '@/services'
import CreateTrackCodeDialog from './createTrackCodeDialog.vue'
import SeeTrackCodeProgressDialog from './seeTrackCodeProgressDialog.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { mapActions, mapGetters } from 'vuex'
import { checkPermissions } from '@/helpers/custom'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Ulaanbaatar')
export default {
  name: 'TrackCodeView',
  components: {
    CreateTrackCodeDialog,
    SeeTrackCodeProgressDialog
  },
  data () {
    return {
      multipleSelection: [],
      currentPage: 1,
      pageSize: 100,
      data: [],
      columns: [],
      searchQuery: null,
      targetTrackCode: {},
      totalRecords: null,
      formData: {},
      progress_code: null,
      progress_name_dialog: null,
      progress_name: 'Хэрэглэгч бүртгэсэн',
      totalHereglegchBvrgesen: 0,
      totalEreenAguulah: 0,
      totalMongolSalbar: 0,
      totalHvrgelt: 0,
      totalOchijAvah: 0,
      totalHadgaluulah: 0,
      totalJoloochidHuviaralsan: 0,
      cancelTrackCode: 0,
      totalSalbartUldsen: 0,
      totalHvleenAwsan: 0,
      checkTrackCode: 0,
      startDate: null,
      endDate: null,
      formDataDialog: {
        selectedTrackCodes: [],
        totalPrice: 0,
        countTrackCode: 0,
        is_paid: false,
        paid_type: 'cash',
        driver_id: null,
        address_id: null,
        deliveryProgress: 160,
        giveUser: 200,
        getProgress: 140,
        saveProgress: 150,
        atBranchProgress: 170,
        startDate: new Date(),
        endDate: null,
        description: null
      },
      dialogName: null,
      is_paid_dialog: false,
      is_delivery_dialog: false,
      is_give_dialog: false,
      is_paid_and_delivery_dialog: false,
      is_paid_and_give_user_dialog: false,
      is_get_dialog: false,
      is_branch_dialog: false,
      is_uldsen_dialog: false,
      driversList: [],
      user: [],
      sumTransaction: 0,
      sumCash: 0,
      sumCard: 0,
      sumNotPay: 0,
      branch_id: null,
      excelData: []
    }
  },
  created () {
    this.loadData(100)
  },
  computed: {
    ...mapGetters([
      'cdnGetter'
    ])
  },
  methods: {
    filterIrsenSalbar (value, row) {
      return row.irsen_salbariin_ner === value
    },
    filterPaid (value, row) {
      return row.is_paid === value
    },
    filterPaidType (value, row) {
      return row.paid_type === value
    },
    exportToExcel () {
      this.loadDataDownloadExcel()
      // 1. Өгөгдлийг өөрчлөх
      const formattedData = this.excelData.map(item => ({
        Дугаар: item.id,
        Трак_код: item.track_code,
        Трак_код_үүсгэсэн_огноо: item.progress_created_at,
        Утасны_дугаар: item.phone_number,
        Үнэ: item.price,
        Жин: item.jin,
        Урт: item.urt,
        Өргөн: item.urgun,
        Төлбөр_төлсөн_эсэх: this.isPaid(item.is_paid),
        Төлбөр_төлсөн_огноо: item.paid_date,
        Төлөв_үүсгэсэн_огноо: item.progress_created_at,
        Хадгалуулж_эхлэх_огноо: item.start_date,
        Хадгалуулж_дуусах_огноо: item.end_date,
        Тавиурын_дугаар: item.taviur_code,
        Төлөв: this.progressStatusReturn(item.progress_code),
        Төлбөрийн_төлөв: this.paidTypeLabel(item.paid_type),
        Хэрэглэгч_хүлээн_авах_салбар: item.branch_name,
        Ачаа_ирсэн_салбар: item.irsen_salbariin_ner
      }))

      // 2. Excel Sheet үүсгэх
      const worksheet = XLSX.utils.json_to_sheet(formattedData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Table Data')

      // 3. Файл татах
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' })
      saveAs(data, 'table_data.xlsx')
    },
    openDialog (data) {
      this.dialogName = data
      if (this.dialogName === 'is_paid') {
        this.is_paid_dialog = true
      } else if (this.dialogName === 'is_delivery') {
        this.getDriver()
        this.getAddress()
        this.is_delivery_dialog = true
      } else if (this.dialogName === 'is_give') {
        this.is_give_dialog = true
      } else if (this.dialogName === 'is_paid_and_delivery') {
        this.getDriver()
        this.getAddress()
        this.is_paid_and_delivery_dialog = true
      } else if (this.dialogName === 'is_paid_and_give_user') {
        this.is_paid_and_give_user_dialog = true
      } else if (this.dialogName === 'is_mongolia') {
        this.is_mongolia_dialog = true
      } else if (this.dialogName === 'is_get') {
        this.is_get_dialog = true
      } else if (this.dialogName === 'is_branch') {
        this.is_branch_dialog = true
      } else if (this.dialogName === 'is_uldsen') {
        this.is_uldsen_dialog = true
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      // val.forEach(element => {
      //   this.formDataDialog.selectedTrackCodes = element.track_code
      // })
      this.formDataDialog.selectedTrackCodes = val.map(element => element.track_code)
      this.formDataDialog.totalPrice = val.reduce(element => element.price + this.formDataDialog.totalPrice)
      this.formDataDialog.totalPrice = val.reduce((sum, element) => sum + element.price, 0)
      this.formDataDialog.countTrackCode = val.length
    },
    timeSince (datestring) {
      const date1 = dayjs(datestring)
      const date2 = dayjs().tz('Asia/Ulaanbaatar')
      let seconds = date2.diff(date1)
      seconds = seconds / 1000

      let interval = Math.floor(seconds / 31536000)

      if (interval > 1) {
        return interval + ' жил'
      }
      interval = Math.floor(seconds / 2592000)
      if (interval > 1) {
        return interval + ' сар'
      }
      interval = Math.floor(seconds / 86400)
      if (interval > 1) {
        return interval + 'өдөр'
      }
      interval = Math.floor(seconds / 3600)
      if (interval > 1) {
        return interval + ' цаг'
      }
      interval = Math.floor(seconds / 60)
      if (interval > 1) {
        return interval + ' минут'
      }
      return Math.floor(seconds) + ' секунд'
    },
    ...mapActions(['setCreateTrackCodeDialog', 'setSeeTrackCodeProgressDialog', 'fullScreenLoading']),
    paidTypeLabel (data) {
      switch (data) {
        case 'cash':
          return 'Бэлэн төлөлт'
        case 'transaction':
          return 'Шүлжүүлэг'
        case 'card':
          return 'Карт'
        case 'notpay':
          return 'Төлбөргүй'
        case 'cupon':
          return 'Купон'
      }
    },
    isPaid (data) {
      switch (data) {
        case false:
          return 'Төлөөгүй'
        case true:
          return 'Төлсөн'
      }
    },
    async loadDataDownloadExcel () {
      try {
        const response = await services.get('trackCodesExcel', {
          params: {
            progress_code: this.progress_code,
            startDate: this.startDate,
            endDate: this.endDate
          }
        })
        if (response) {
          this.excelData = response.data
          const formattedData = this.excelData.map(item => ({
            Дугаар: item.id,
            Трак_код: item.track_code,
            Трак_код_үүсгэсэн_огноо: item.progress_created_at,
            Утасны_дугаар: item.phone_number,
            Үнэ: item.price,
            Жин: item.jin,
            Урт: item.urt,
            Өргөн: item.urgun,
            Төлбөр_төлсөн_эсэх: this.isPaid(item.is_paid),
            Төлбөр_төлсөн_огноо: item.paid_date,
            Төлөв_үүсгэсэн_огноо: item.progress_created_at,
            Хадгалуулж_эхлэх_огноо: item.start_date,
            Хадгалуулж_дуусах_огноо: item.end_date,
            Тавиурын_дугаар: item.taviur_code,
            Төлөв: this.progressStatusReturn(item.progress_code),
            Төлбөрийн_төлөв: this.paidTypeLabel(item.paid_type),
            Хэрэглэгч_хүлээн_авах_салбар: item.branch_name,
            Ачаа_ирсэн_салбар: item.irsen_salbariin_ner
          }))

          // 2. Excel Sheet үүсгэх
          const worksheet = XLSX.utils.json_to_sheet(formattedData)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Table Data')

          // 3. Файл татах
          const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
          const data = new Blob([excelBuffer], { type: 'application/octet-stream' })
          saveAs(data, 'table_data.xlsx')
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Erroe fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачааллахад алдаа гарлаа: ${error.message} `)
      }
    },
    async searchItem (data) {
      if (!data) {
        this.$alert('Уучлаарай. Хайх утга оруулна уу.', 'Хоосон', {
          confirmButtonText: 'Ойлголоо'
        })
        return
      }
      try {
        const trackCode = data
        const payload = trackCode
        const response = await services.get(`trackCodesPaginationSearch/${payload}`)
        console.log(payload)
        if (response.type === 'success') {
          this.data = response.data
        } else {
          this.$message.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Алдаа гарлаа:', error)
        this.$message.error('Өгөгдлийг татахад алдаа гарлаа!')
      }
    },
    async loadData (data) {
      try {
        this.fullScreenLoading(true)
        this.progress_code = data
        const response = await services.get(`getTrackCodes?page=${this.currentPage}&limit=${this.pageSize}&selected_component=${data}&startDate=${this.startDate}&endDate=${this.endDate}&searchQuery=${this.searchQuery}`)
        if (response.type === 'success') {
          this.data = []
          this.data = response.data
          this.totalRecords = response.total
          this.totalPages = response.data.length
          this.totalHereglegchBvrgesen = response.userRegister
          this.totalMongolSalbar = response.mongolSalbar
          this.totalEreenAguulah = response.ereeneesGarsan
          this.totalHvrgelt = response.deliveryCount
          this.totalJoloochidHuviaralsan = response.deliveryWorkerCount
          this.totalHadgaluulah = response.saveCount
          this.totalOchijAvah = response.ochijAvahCount
          this.totalSalbartUldsen = response.uldsen
          this.totalHvleenAwsan = response.success
          this.checkTrackCode = response.checkTrackCode
          this.cancelTrackCode = response.cancelTrackCode
          this.fullScreenLoading(false)
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
          this.$root.fullscreenLoading = false
        }
      } catch (error) {
        console.error('Erroe fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачааллахад алдаа гарлаа: ${error.message} `)
        this.fullScreenLoading(false)
      }
    },
    handlePageChange (page) {
      this.currentPage = page
      this.loadData(this.progress_code)
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    createTrackCodeDialogOpen (data) {
      this.targetTrackCode = data
      this.setCreateTrackCodeDialog(true)
    },
    async seeTrackCodeProgressDialogOpen (data) {
      try {
        const payload = data.id
        const response = await services.get(`trackCodesId/${payload}`)
        if (response.type === 'success') {
          this.formData = response.data
          this.setSeeTrackCodeProgressDialog(true)
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async deleteRow (row) {
      try {
        await ElMessageBox.confirm('Та энэ бичлэгийг устгахдаа итгэлтэй байна уу?', 'Баталгаажуулалт', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })

        // API устгах хүсэлт явуулах
        await services.delete('trackCodes', row.id)
        this.loadData()
        // Success message
        ElMessage.success('Амжилттай устгагдлаа!')
        // Remove row from data after deletion
        const index = this.data.indexOf(row)
        if (index > -1) {
          this.data.splice(index, 1)
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('Устгахад алдаа гарлаа!')
        }
      }
    },
    // async searchItem (data) {
    //   if (!data) {
    //     this.$alert('Уучлаарай. Хайх утга оруулна уу.', 'Хоосон', {
    //       confirmButtonText: 'Ойлголоо'
    //     })
    //     return
    //   }
    //   try {
    //     const response = await services.get('trackCodesPaginationSearch', {
    //       params: {
    //         page: this.currentPage,
    //         limit: this.pageSize,
    //         startDate: this.startDate,
    //         endDate: this.endDate,
    //         track_code: this.searchQuery
    //       }
    //     })
    //     if (response) {
    //       this.data = response.data
    //       this.totalRecords = response.total
    //       this.totalPages = response.data.length
    //       this.HereglegchBvrtgesen = response.HereglegchBvrtgesen
    //       this.EreenAguulah = response.EreenAguulah
    //       this.MongolSalbar = response.MongolSalbar
    //       this.Hvrgelt = response.Hvrgelt
    //       this.OchijAvah = response.OchijAvah
    //       this.Hadgaluulah = response.Hadgaluulah
    //       this.JoloochidHuviaralsan = response.JoloochidHuviaralsan
    //       this.SalbartUldsen = response.SalbartUldsen
    //       this.HvleenAwsan = response.HvleenAwsan
    //     } else {
    //       this.$message.error('Өгөгдөл олдсонгүй!')
    //     }
    //   } catch (error) {
    //     console.error('Алдаа гарлаа:', error)
    //     this.$message.error('Өгөгдлийг татахад алдаа гарлаа!', error)
    //   }
    // },
    clearSearch () {
      this.searchQuery = null
      this.loadData(100)
    },
    filterHandler (value, row, column) {
      const property = column.property
      return row[property] === value
    },
    async paymentSuccess () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгч салбараас очиж авах трак код сонгоно уу!',
            type: 'error'
          })
        }
        if (!this.formDataDialog.is_paid === false) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Төлбөр төлсөн болгно уу!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`updateIsPayedAdmin?track_code=${trackCodes}&is_paid=${this.formDataDialog.is_paid}&paid_type=${this.formDataDialog.paid_type}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Трак кодуудын төлбөр амжилттай төлөгдлөө'
          })
          this.is_paid_dialog = false
          this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async getDriver () {
      try {
        const response = await services.get('drivers')
        if (response.type === 'success') {
          this.driversList = response.data
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async getAddress () {
      try {
        const payload = { track_code: this.formDataDialog.selectedTrackCodes }
        const response = await services.get('phoneNumberAdmin', payload)
        if (response.type === 'success') {
          this.user = response.data
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async hurgeltendGargahCheck () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хүргэлтэнд гаргах трак код сонгоно уу!',
            type: 'error'
          })
        } else if (!this.formDataDialog.address_id) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгчийн хүлээн авах хаяг сонгоно уу!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`toHurgeltCheckAdmin?track_code=${trackCodes}&address_id=${this.formDataDialog.address_id}&driver_id=${this.formDataDialog.driver_id}
        &progress_code=${this.formDataDialog.deliveryProgress}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Ачаануудыг амжилттай жолоочин хуваариллаа',
            type: 'success'
          })
          this.is_give_dialog = false
          // this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async hereglegchidOlgohCheck () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгчид олгох трак код сонгоно уу!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`toHurgeltCheckAdmin?track_code=${trackCodes}&progress_code=${this.formDataDialog.giveUser}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Ачаануудыг амжилттай хэрэглэгчид олголоо.',
            type: 'success'
          })
          this.is_delivery_dialog = false
          // this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async paymentAndDelivery () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгчид олгох трак код сонгоно уу!',
            type: 'error'
          })
        }
        if (this.formDataDialog.is_paid === false) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Ачааны төлбөр төлнө үү!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`paymentAndDelivery?track_code=${trackCodes}&progress_code=${this.formDataDialog.deliveryProgress}
        &is_paid=${this.formDataDialog.is_paid}&paid_type=${this.formDataDialog.paid_type}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Ачаануудын төлбөр амжилттай төлөгдөж хүргэлтэнд гарлаа.',
            type: 'success'
          })
          this.is_delivery_dialog = false
          // this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async paymentAndGiveUser () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгчид олгох трак код сонгоно уу!',
            type: 'error'
          })
        }
        if (this.formDataDialog.is_paid === false) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Ачааны төлбөр төлнө үү!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`paymentAndDelivery?track_code=${trackCodes}&progress_code=${this.formDataDialog.giveUser}
        &is_paid=${this.formDataDialog.is_paid}&paid_type=${this.formDataDialog.paid_type}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Ачаануудын төлбөр амжилттай төлөгдөж хэрэглэгчид олголоо.',
            type: 'success'
          })
          this.is_delivery_dialog = false
          // this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async getCheck () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгч салбараас очиж авах трак код сонгоно уу!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`toHurgeltCheckAdmin?track_code=${trackCodes}&progress_code=${this.formDataDialog.getProgress}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Ачаануудыг амжилттай хэрэглэгчид олголоо.',
            type: 'success'
          })
          this.is_delivery_dialog = false
          // this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async saveCheck () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгч салбараас очиж авах трак код сонгоно уу!',
            type: 'error'
          })
        }
        if (!this.formDataDialog.startDate) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хадгалуулж эхлэх огноо оруулна уу!',
            type: 'error'
          })
        }
        if (!this.formDataDialog.endDate) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хадгалуулж дуусах огноо оруулна уу!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`toHurgeltCheckAdmin?track_code=${trackCodes}&progress_code=${this.formDataDialog.saveProgress}
        &start_date=${this.formDataDialog.startDate}&end_date=${this.formDataDialog.endDate}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Ачаануудыг амжилттай хэрэглэгчид олголоо.',
            type: 'success'
          })
          this.is_delivery_dialog = false
          // this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    async atBranchCheck () {
      try {
        if (!this.formDataDialog.selectedTrackCodes.length) {
          return this.$notify({
            title: 'Уучлаарай',
            message: 'Хэрэглэгч салбараас очиж авах трак код сонгоно уу!',
            type: 'error'
          })
        }

        const trackCodes = this.formDataDialog.selectedTrackCodes.join(',')
        const response = await services.get(`toHurgeltCheckAdmin?track_code=${trackCodes}&progress_code=${this.formDataDialog.atBranchProgress}
        &description=${this.formDataDialog.description}`)
        if (response.type === 'success') {
          this.$notify({
            title: 'Амжилттай',
            message: 'Ачаануудыг амжилттай хэрэглэгчид олголоо.',
            type: 'success'
          })
          this.is_delivery_dialog = false
          // this.formDataDialog.selectedTrackCodes = []
          this.dialogName = null
          location.reload()
        } else {
          ElMessage.error('Өгөгдөл татхад алдаа гарлаа')
        }
      } catch (error) {
        ElMessage.error(`Алдаа: ${error.message}`)
      }
    },
    progressStatusReturn (data) {
      if (data === 100) {
        return 'Хэрэглэгч бүртгэсэн'
      } else if (data === 110) {
        return 'Эрээн дах агуулахаас гарсан'
      } else if (data === 120) {
        return 'Монгол дах салбар хүлээн авсан'
      } else if (data === 130) {
        return 'Хэрэглэгч хүргэлтээр авна'
      } else if (data === 140) {
        return 'Хэрэглэгч салбараас очиж авна'
      } else if (data === 150) {
        return 'Хэрэглэгч салбар дээр хадгалуулна'
      } else if (data === 160) {
        return 'Хүргэлтийн ажилтанд хуваарилсан'
      } else if (data === 170) {
        return 'Ачаа салбар дээр үлдсэн'
      } else if (data === 200) {
        return 'Хэрэглэгч хүлээн авсан'
      } else if (data === 109) {
        return 'Тодорхойгүй'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* TrackCode Container */
.trackcode-container {
  padding: 0;
}

/* Status Cards Card */
.status-cards-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 24px;
}

.status-header {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.status-header-icon {
  color: #667eea;
  font-size: 20px;
}

.status-header-title {
  color: #1f2937;
}

.status-cards-row {
  margin: 0 -8px;
}

/* Modern Status Cards */
.modern-status-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  padding: 16px;
  text-align: center;
  height: 100%;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modern-status-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.status-icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  font-size: 24px;
}

.status-card-primary .status-icon-wrapper {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.status-card-info .status-icon-wrapper {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
}

.status-card-success .status-icon-wrapper {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.status-card-warning .status-icon-wrapper {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.status-card-danger .status-icon-wrapper {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
}

.status-card-secondary .status-icon-wrapper {
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: white;
}

.status-icon {
  font-size: 24px;
}

.status-content {
  width: 100%;
}

.status-value {
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
  line-height: 1.2;
}

.status-label {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.3;
  word-break: break-word;
}

/* Legacy Styles (for backward compatibility) */
.card_niit_text {
  font-size: 14px;
  font-weight: bold;
}

.icon_color {
  color: #003d99;
}

.small_card_border {
  border-radius: 15px !important;
}

.text_align_center {
  text-align: center;
  line-height: 10px;
}

.card_tom_text {
  font-size: 13px;
}

.card_text {
  font-size: 10px;
  line-height: 2px;
}

.header_zone {
  background-color: white;
}

.flr {
  float: right;
}

.el-table {
  margin-bottom: 20px;
}

.cursor {
  cursor: pointer;
}

.m-b-10 {
  margin-bottom: 10px;
}

.m-t-10 {
  margin-top: 10px;
}

.card_design {
  border-radius: 20px;
}

/* Responsive */
@media (max-width: 1200px) {
  .status-value {
    font-size: 20px;
  }

  .status-label {
    font-size: 10px;
  }

  .status-icon-wrapper {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .status-cards-card {
    margin-bottom: 16px;
  }

  .status-header {
    font-size: 16px;
    padding: 12px;
  }

  .status-cards-row {
    margin: 0 -4px;
  }

  .modern-status-card {
    min-height: 100px;
    padding: 10px 8px;
  }

  .status-icon-wrapper {
    width: 36px;
    height: 36px;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .status-value {
    font-size: 16px;
    margin-bottom: 4px;
  }

  .status-label {
    font-size: 8px;
    line-height: 1.2;
  }
}

@media (max-width: 480px) {
  .status-cards-row {
    margin: 0 -2px;
  }

  .modern-status-card {
    min-height: 90px;
    padding: 8px 4px;
  }

  .status-icon-wrapper {
    width: 32px;
    height: 32px;
    font-size: 16px;
    margin-bottom: 6px;
  }

  .status-value {
    font-size: 14px;
  }

  .status-label {
    font-size: 7px;
  }
}

/* Mobile Table Scroll for TrackCode */
@media (max-width: 768px) {
  .el-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .el-table {
    min-width: 800px;
  }

  .el-table :deep(.el-table__body-wrapper) {
    overflow-x: auto;
  }
}
</style>
